import { useEffect, useState } from "react";
import { SpinnerC } from "../../components/spinners/SpinnerC";
import { ErrorOccurred } from "../../services/utils/ErrorOccurred";
import { getResWhoLiked } from "../../services/callAPI/togetGetResWhoLiked";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import RetourButton from "../../components/backReturn/BackReturn";

export interface residentWhoLikedProps {
  pseudo: string;
  region: string;
}

function WhoEnjoyedTrocsPage() {
  const [whoLiked, setwhoLiked] = useState<null | residentWhoLikedProps[]>(null);
  const [hasError, sethasError] = useState<boolean>(false);

  const { trocIdTrav } = useParams();

  useEffect(() => {
    const getResWhoLikedTroc = async () => {
      try {
        const resWhoLiked = await getResWhoLiked(trocIdTrav);
        setwhoLiked(resWhoLiked);
      } catch (error) {
        sethasError(true);
      }
    };

    getResWhoLikedTroc();
  }, [trocIdTrav]); // ✅ Ajout de la dépendance manquante

  if (whoLiked) {
    return (
      <section id="section-who-liked-troc"
        className="p-6 max-w-3xl mx-auto flex flex-col gap-2"
      >
        <div className="hidden md:block">
          <RetourButton />
        </div>

        <h1 className="text-2xl font-bold mb-6">Liste des résidents ayant liké ce troc</h1>

        <ul id="ul-who-liked-troc" className="space-y-4">
          {whoLiked.map((res, index) => (
            <li
              key={index}
              className="flex items-center gap-4 p-4 bg-white rounded-lg shadow hover:shadow-md transition"
            >
              <FontAwesomeIcon icon={faHeart} className="text-red-500 text-xl" />
              <div>
                <p className="font-semibold text-gray-800">{res.pseudo} a liké</p>
                <p className="text-sm text-gray-500">Région : {res.region}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="block md:hidden fixed bottom-24 left-4 right-4 z-50">
          <RetourButton />
        </div>
      </section>
    );
  } else if (hasError) {
    return <ErrorOccurred />;
  } else {
    return <SpinnerC />;
  }
}

export default WhoEnjoyedTrocsPage;


/*import { useEffect, useState } from "react";
import { SpinnerC } from "../../components/spinners/SpinnerC";
import { ErrorOccurred } from "../../services/utils/ErrorOccurred";
import { getResWhoLiked } from "../../services/callAPI/togetGetResWhoLiked";
import { useParams } from 'react-router-dom';

export interface residentWhoLikedProps {
  pseudo: string;
  region: string;
}

function whoEnjoyedTrocsPage() {
  const [whoLiked, setwhoLiked] = useState<null | residentWhoLikedProps[]>(null);
  const [hasError, sethasError] = useState<boolean>(false);

  const { trocIdTrav } = useParams();

  //useffecto get residents who liked troc
  useEffect(() => {
    try {
      //call api
      const getResWhoLikedTroc = async () => {
        const resWhoLiked = await getResWhoLiked(trocIdTrav);

        setwhoLiked(resWhoLiked);
      }

      getResWhoLikedTroc();

    } catch (error) {
      sethasError(true);
    }
  });

  if (whoLiked) {
    return (
      <section id="section-who-liked-troc">
        <h1>Liste des résidents ayant liké ce troc</h1>

        <ul id="ul-who-liked-troc">
          {whoLiked.map((res, index) => (
            <li key={index}>
              {res.pseudo} a liké. Et se trouve en région {res.region}
            </li>
          ))}
        </ul>
      </section>
    )
  } else if (hasError) {
    return <ErrorOccurred />
  }
  else {
    return <SpinnerC />
  }
}
export default whoEnjoyedTrocsPage;*/